// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"21deec47","123":"4ef1f391","155":"8832b747","401":"ddb783cc","453":"2baa2eb5","629":"c57129e2"}[chunkId] + ".chunk.js";
};